import React from 'react';
import AppLayout from '../components/AppLayout'; 
import Review from '../components/Review';

const ReviewPage = () => {
  return (
    <AppLayout>
      <Review />
    </AppLayout>
  );
};

export default ReviewPage;
